
import React, { Component } from 'react';
import './myStyles.css';

class App extends Component {

  state = {
    win: false,
    score: 0,
    clickedFriends: [],
    friends: [
      {
        name: "dog",
        img: require('./images/Dog.png'),
        id: 1,
      },
      {
        name: "cat",
        img: require('./images/Cat.png'),
        id: 2,
      },
      {
        name: "bunny",
        img: require('./images/Bunny.png'),
        id: 3,
      },
      {
        name: "bird",
        img: require('./images/Bird.png'),
        id: 4,
      },
      {
        name: "chinchilla",
        img: require('./images/Chinchilla.png'),
        id: 5,
      },
    ]
  }

  roundReset = () => {
    let { clickedFriends, score, friends, roundEnd , win} = this.state

    clickedFriends = []
    score = 0
    roundEnd = false

    this.setState({
      clickedFriends,
      score,
      friends,
      roundEnd,
      win
    })
  }

  onClick = id => {
    console.log({ id }, "has been clicked!");
    let { clickedFriends, score, friends, roundEnd, win } = this.state
    let friendCount = friends.length;
    let friendSelected;
    let temp;

    if (clickedFriends.includes(id)) {
      console.log("You lost, as predicted.");
      roundEnd = true;
      setTimeout(this.roundReset, 2000);
    } else {
      score++;
      clickedFriends.push(id);
  
      if (score === friendCount) {
        win = true;
        roundEnd = true;
        setTimeout(this.roundReset, 2000);
      }
    }

    while (friendCount > 0) {
      friendSelected = Math.floor(Math.random() * friendCount);
      friendCount--;
      temp = friends[friendCount];
      friends[friendCount] = friends[friendSelected];
      friends[friendSelected] = temp;
    }

    this.setState({
      clickedFriends,
      score,
      friends,
      roundEnd,
      win
    });
  }

  render() {
    return (
      <div className="App">
        <h1>Clicky Friends</h1>
        <p>Click all the friends, without duplication, or you lose.</p>
        <h3>Score: {this.state.score}</h3>
        <div className="friend-zone">
          {(this.state.roundEnd && !this.state.win) ? <div><h1>You lose.</h1></div>
          : (this.state.roundEnd && this.state.win) ? <div><h1>Congratulations, you've won!</h1></div>
          : 
          this.state.friends.map(friend =>
            // console.log(friend)
            <img src={friend.img}
              onClick={() => this.onClick(friend.id)}
              key={friend.id}
              alt={friend.name}
            />
          )}

        </div>
      </div>
    )
  }
}

export default App;
